// @ts-nocheck
import GlobalStyles from '../common/theme/GlobalStyles';
import theme from '../common/theme/theme';
import HUDTracker from '../features/HUD/components/HUDTracker';
import { store } from './store';
import React, { FunctionComponent, ReactNode } from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import {ThemeProvider} from 'styled-components';
import ContextMenu from "../common/ContextMenu";

type AnyIfEmpty<T extends object> = keyof T extends never ? any : T;

interface ProvidersProps {
	children?: ReactNode | ReactNode[];
}

export interface ThemeProviderProps<T extends object, U extends object = T> {
    children?: ReactNode | ReactNode[] | undefined;
    theme: T | ((theme: U) => T);
}

export type BaseThemeProviderComponent<T extends object, U extends object = T> = React.ComponentClass<
    ThemeProviderProps<T, U>
>;
export type ThemeProviderComponent<T extends object, U extends object = T> = BaseThemeProviderComponent<
    AnyIfEmpty<T>,
    AnyIfEmpty<U>
>;


const Providers: FunctionComponent<ProvidersProps> = ({ children }) => {

	document.addEventListener("contextmenu", (event) => {
        event.preventDefault();
        const xPos = event.pageX + "px";
        const yPos = event.pageY + "px";
    });

	return (
		<ReduxProvider store={store}>
			<BrowserRouter>
				<HUDTracker>
					<ThemeProvider theme={theme}>
						<GlobalStyles />
						{children}
						<ContextMenu />
					</ThemeProvider>
				</HUDTracker>
			</BrowserRouter>
		</ReduxProvider>
	);
};

export default Providers;

